import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoSetEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoSetEventDTO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly data: RoomBrandLogoSetEvent) {
    JsonSchemaValidator.assert(RoomBrandLogoSetEventDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      }
    };
  }
}

interface RoomBrandLogoSetEvent {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
